import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationVetNotificationType } from '../../models/notifications/notification-vet.model';

@Component({
  selector: 'app-notification-type-popup',
  templateUrl: './notification-type-popup.component.html',
  styleUrls: ['./notification-type-popup.component.scss']
})
export class NotificationTypePopupComponent implements OnInit {
  @Input() notificationTypes: NotificationVetNotificationType[] = [];
  @Input() selectedTypes: NotificationVetNotificationType[] = [];
  @Input() title: string = '';
  groupedNotificationTypes: any[] = [];
  selectedTypeIds: Set<number> = new Set<number>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.selectedTypes.forEach(type => this.selectedTypeIds.add(type.notificationTypeId));
    this.groupedNotificationTypes = this.groupBy(this.notificationTypes, 'notificationGroupId');

  }
 

  groupBy(array: any[], key: string) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  }


  areAllSelected(groupId: number): boolean {
    const group = this.groupedNotificationTypes[groupId];
    return group.every((type:any) => this.selectedTypeIds.has(type.notificationTypeId));
  }

  hasSelection(groupId: number): boolean {
    const group = this.groupedNotificationTypes[groupId];
    return group.some((type: any) => this.selectedTypeIds.has(type.notificationTypeId));
  }


  toggleSelectAll(event: MatCheckboxChange, groupId: number): void {
    const checked = event.checked; // MatCheckboxChange provides the `checked` property directly
    const group = this.groupedNotificationTypes[groupId];

    if (checked) {
      group.forEach((type: any) => this.selectedTypeIds.add(type.notificationTypeId));
    } else {
      group.forEach((type: any) => this.selectedTypeIds.delete(type.notificationTypeId));
    }
  }
  toggleSelection(notificationTypeId: number): void {
    if (this.selectedTypeIds.has(notificationTypeId)) {
      this.selectedTypeIds.delete(notificationTypeId);
    } else {
      this.selectedTypeIds.add(notificationTypeId);
    }
  }

  save(): void {
    const updatedTypes = this.notificationTypes.filter(type => this.selectedTypeIds.has(type.notificationTypeId));
    this.activeModal.close(updatedTypes);
  }

  close(): void {
    this.activeModal.dismiss();
  }


}
